import cookies from "js-cookie"
import { DateTime } from "luxon"
import { CookiesEnum } from "./context"

export function setLoginCookie(token: string) {
  let domain = "joinbonsai.co"
  if (process.env.NEXT_PUBLIC_ENV === "development") {
    domain = "bonsailocal.com"
  } else if (process.env.NEXT_PUBLIC_ENV === "staging") {
    domain = "staging.joinbonsai.co"
  } else if (process.env.NEXT_PUBLIC_ENV === "playground") {
    domain = "playground.joinbonsai.co"
  }
  cookies.set(CookiesEnum.Token, token, {
    domain,
    sameSite: "none",
    secure: true,
    path: "/",
    expires: DateTime.local().plus({ years: 1 }).toJSDate(),
  })
}
